import { Alert, Button, Select, SelectItem } from '@heroui/react';
import { Icon } from '@iconify/react';
import _ from 'lodash';
import { useCallback, useMemo } from 'react';
import { useImmer } from 'use-immer';

import { useUpdateProfileMutation } from '@/patient-app-common/api/patientApi';

export function DemoProfile({ initProfile }) {
  const [updateProfile, { isLoading, isSuccess, isError }] =
    useUpdateProfileMutation();
  const [profile, setProfile] = useImmer(initProfile);

  const handleProfileValueSelect = useCallback((e, keyId) => {
    setProfile((draft) => {
      draft[keyId].wasUpdated = true;
      draft[keyId].value = e.target.value;
    });
  }, []);

  const params = useMemo(() => {
    const keysToUpdate = {};

    for (const key in profile) {
      if (profile[key].wasUpdated && !_.isEmpty(profile[key].value)) {
        keysToUpdate[key] = profile[key].value;
      }
    }

    return keysToUpdate;
  }, [profile]);

  const handleSubmit = async () => {
    if (_.isEmpty(params)) return;
    await updateProfile(params);
  };

  return (
    <div className="space-y-4">
      <Alert
        className="max-w-lg"
        color="danger"
        description="An error occured and your changes were not saved."
        hideIconWrapper
        isVisible={isError}
        variant="faded"
      />
      <Alert
        className="max-w-lg"
        color="success"
        description="Your changes were saved."
        hideIconWrapper
        isVisible={isSuccess}
        variant="faded"
      />
      {Object.keys(profile).map((i) => {
        const keyName = profile[i].key;
        const selectedValue = profile[i].value;
        const { keyId } = profile[i];
        const { options } = profile[i];
        const unset = !options.includes(selectedValue);

        return (
          <div key={keyId}>
            <Select
              className="max-w-xs"
              label={keyName}
              placeholder="Select an option"
              defaultSelectedKeys={unset ? [] : [selectedValue]}
              variant="bordered"
              onChange={(e) => handleProfileValueSelect(e, keyId)}
            >
              {options.map((option) => (
                <SelectItem key={option}>{option}</SelectItem>
              ))}
            </Select>
          </div>
        );
      })}
      <Button
        color="primary"
        isLoading={isLoading}
        onPress={handleSubmit}
        startContent={
          !isLoading && <Icon icon="tabler:edit" className="text-lg" />
        }
        variant="bordered"
      >
        Save Profile
      </Button>
    </div>
  );
}
